@if (active) {
  <div animate.enter="fade-enter" style="--time: 200ms">
    <ng-content></ng-content>
  </div>
}
